module.exports = __webpack_public_path__ + "img/history-version-en.c5a6df66.png";